// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);

  // Report to Klaviyo, including size and color
  const product = evt.detail.product;

  // SKU Format: "FA24120-Navy-4" (internal id - color - size)
  const skuRegExp = /^[0-9A-Z]+?-(.+)-(.+?)$/;
  const sku = typeof product.sku === "string" ? product.sku : "";
  const matchResult = sku.match(skuRegExp);

  if (matchResult && globalThis.klaviyo) {
    const [, variantColor, variantSize] = matchResult;

    const klaviyoPayload = {
      URL: location.href,
      "Product Name": product.product_title,
      ProductId: Number(product.product_id),
      VariantID: Number(product.variant_id),
      "Variant Name": product.title,
      Price: Number(product.discounted_price / 100),
      CompareAtPrice: Number(product.original_price / 100),
      "Variant SKU": product.sku,
      Quantity: Number(product.quantity),
      Categories: [product.product_type],
      Brand: product.vendor,
      ImageURL: product.featured_image?.url ?? null,
      "VariantOptions": [
        {
          Title: "Size",
          Name: variantSize
        },
        {
          Title: "Color",
          Name: variantColor
        }
      ]
    };
    
    klaviyo.track("Add To Cart (Custom)", klaviyoPayload);
  }
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  const backInStock = document.getElementById('backInStockForm');
  document.getElementById('variantID').value = evt.detail.variant.id;
  document.getElementById('variantSKU').value = evt.detail.variant.sku;
  document.getElementById('variantPrice').value = evt.detail.variant.price;
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  if (backInStock) {
    if (evt.detail.variant.available) {
      backInStock.style.display = 'none';
    } else {
      backInStock.style.display = 'flex';
    }
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

function initInternalLinkingComponentAnimations() {
  const sections = document.querySelectorAll(
    '[data-section-type="internal-linking-component"].animation.animation--internal-linking-component'
  );
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.01 }
  );

  sections.forEach((section) => observer.observe(section));
}

document.addEventListener("DOMContentLoaded", initInternalLinkingComponentAnimations);
document.addEventListener("shopify:section:load", initInternalLinkingComponentAnimations);
document.addEventListener("shopify:section:reorder", initInternalLinkingComponentAnimations);
